module.exports = __webpack_public_path__ + "img/youku.66386c2b.png";